//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      //sports: []
    }
  },
  computed: {
    sports() {
      let sports = _.get(this.$store.state, 'sports', [])
      sports = _.filter(sports, { category: 'esport' })
      sports = _.filter(sports, function (o) {
        return o.event_count > 0
      })
      sports = _.filter(sports, function (o) {
        return !o.is_parent
      })
      return sports
    }
  },
  methods: {
    getURL(sport) {
      let prefix = '/e-sports/'
      if (this.lang == 'ro') {
        prefix = process.env.BOOKMAKER == 'netbetcom' ? '/esports/' : '/e-sporturi/'
      }
      return prefix + sport.translated_slug + '/'
    }
  }
}
